import React, { useState, useEffect } from "react";
import { Form, Button, Comment, Grid } from "semantic-ui-react";
import format from "date-fns/format";
import { timeComment } from "../staffActions";
import { Formik } from "formik";
import MyTextInput from "../../../app/common/form/MyTextInput";
import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();

export default function TimeComments(props) {
    let parts = window.location.href.split("/");
    let timeId = parts.pop() || parts.pop();
    const [comments, setComments] = useState([]);

    useEffect(() => {
        const unsubscribe = firestore
            .collection("comments")
            .where("timeId", "==", timeId)
            .orderBy("createDate", "desc")
            .onSnapshot((snapshot) => {
                let list = [];
                snapshot.docs.forEach((result) => {
                    if (result.exists) {
                        let obj = { ...result.data(), id: result.id };
                        list.push(obj);
                    }
                });
                console.log(list);
                setComments(list);
            });

        return () => unsubscribe();
    }, []);

    return (
        <div>
            <h2>Comments</h2>

            {comments && comments.length > 0 && (
                <Comment.Group>
                    {comments.map((sr) => (
                        <Comment key={sr.id}>
                            <Comment.Content>
                                <Comment.Author as="a">{sr.author}</Comment.Author>
                                <Comment.Metadata>{format(new Date(sr.createDate.toDate()), "d MMMM yyyy HH:mm:ss")}</Comment.Metadata>
                                <Comment.Text>{sr.comment}</Comment.Text>
                            </Comment.Content>
                        </Comment>
                    ))}
                </Comment.Group>
            )}

            <Formik
                initialValues={{ comment: "" }}
                validate={(values) => {
                    const errors = {};
                    return errors;
                }}
                onSubmit={async (values, { setSubmitting, resetForm }) => {
                    await firestore
                        .collection("comments")
                        .add({ comment: values.comment, author: props.profile["displayName"], userUid: props.time["timeUserUid"], timeId: props.time["id"], createDate: new Date(Date.now()) });
                    resetForm();
                    setSubmitting(false);
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                    <form onSubmit={handleSubmit} className="ui form">
                        <Grid stackable>
                            <Grid.Row columns={3}>
                                <Grid.Column width={2}>
                                    <label>Comment</label>
                                </Grid.Column>

                                <Grid.Column width={10}>
                                    <Form.Field>
                                        <MyTextInput name="comment" />
                                    </Form.Field>
                                </Grid.Column>

                                <Grid.Column width={4}>
                                    <Button disabled={isSubmitting} loading={isSubmitting} fluid size="large" color="blue">
                                        COMMENT
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </form>
                )}
            </Formik>
        </div>
    );
}
